/**
 * Contract tab identifiers
 */
export enum ContractTab {
  DETAILS = 'details',
  ROSTER = 'roster',
  SETTINGS = 'settings',
  ROSTER_OWNERS = 'roster-owners',
  LABOR_CATEGORIES = 'labor-categories',
}

/**
 * Type for tab change handler
 */
export type TabChangeHandler = (tab: ContractTab) => void;

export interface RosterEntry {
  userId: string;
  legalFirstName: string;
  legalLastName: string;
  email: string;
  euaId?: string;
  laborCategory: string;
  vettingProgress: string;
  isUSCitizen: boolean | null;
  sixMonthsOrLess: boolean;
  riskLevel: string;
  scheduledRemovalDate?: string | null;
  vettingStartDate: string;
  vettingEndDate: string;
}

/**
 * Form data for the Roster Owners tab
 */
export interface RosterOwnerFormData {
  rosterOwnerName: string;
  rosterOwnerEmail: string;
  delegateOwnerName?: string;
  delegateOwnerEmail?: string;
}
